import React, { useContext } from 'react'
import { AppContext } from '../../../App'
import axios from 'axios'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight } from '@fortawesome/free-solid-svg-icons'
import config from '../../../config.json'
import { prepareProductUrl } from '../../../services/helpers'

export default function ResinousSystem(props) {
   const { id, name, subheading:shortDescription, description:descriptionDirty, url, image } = props
   const { setCurrentStep,
      setAppHeader,
      setNavState,
      setLinkGoBackTarget,
      productTypeSteps,
      productOptionsSelected,
      setProductOptionsSelected,
      stepsCompleted,
      setStepsCompleted,
      resinousFloorSystems,
      resinousWallSystems,
      resinousCoveSystems,
      setResinousSystemTypes,
      setProductSelected,
      setLoading,
        setAvailableSmallColors,
    setAvailableLargeColors,
    setAvailableSmallChipColors,
       setAvailableLargeChipColors,
       availableSmallChipColors,
       bu
   } = useContext(AppContext)


   const description = descriptionDirty.replace(/(<([^>]+)>)/gi, "")

   // Prepend URL to image, only if image is set, else set to false.
   const systemImage = image && "https://cdn.laticrete.com" + image

   // Clean a given string of a specific character, replaced with a specific replacement character
   function cleanStringOfChar(string, char, replacement) {
      return string.replace(char, replacement)
   }

   // If url is not null, and url includes "webauthor", replace "webauthor." with "" to link to production page. Else set systemUrl to url.
   const systemUrl = url ? (
      url.indexOf('webauthor') > -1 ? url.replace('webauthor.', '') : url
   ) : (
      url
       )

   const { productOptions } = productOptionsSelected
   const resinousApplication = productOptions[2].toLowerCase()
   const iconAngleRight = <FontAwesomeIcon icon={ faAngleRight } color="#00a8d5" />

    const handleResinousSystemSelected = () => {
       // Set the selected product as selectedSystems
       setProductSelected({ name, shortDescription, description, url, image })
      // Update the current step. If cove selected, go directly to cove form. Else go to next step "ResinousSystemTypeSelection"
      resinousApplication==='cove' ? (
         setCurrentStep({ step: "resinousCoveCoverageDetails" })
      ) : (
         setCurrentStep({ step: "resinousSystemTypeSelection" })
      )
      // Update the nav state
      setNavState({ navStep: "Resinous"+productOptions[2]+"SystemSelection" })
      // Set the appHeader for Step state
      setAppHeader("Step 3 of " + (productTypeSteps))
      // Set the Go Back link
      setLinkGoBackTarget({ link: "resinousSystemSelection" })
      // Add the selected resinous application to state of App
      productOptions.push(name)
      setProductOptionsSelected({ productOptions: productOptions })
      // Update the steps completed to include this step.
      stepsCompleted.push("Select "+productOptions[2]+" System")
      setStepsCompleted(stepsCompleted)


      //** Set resinous system type data for the next step, to select an available system type. **/
      // Capture which resinous application was selected
      let applicationType = productOptions[2].toLowerCase()
      // Capture the selected system from the previous step.
      let selectedSystemsType = productOptions[3]
      let selectedSystems, mainSystemId
      switch(applicationType) {
         case "floor": selectedSystems = resinousFloorSystems; break
         case "wall": selectedSystems = resinousWallSystems; break
         case "cove": selectedSystems = resinousCoveSystems; break
         default: alert("No resinous system found.")
      }
      selectedSystems.map(ss => {
         return (
               ss.name===selectedSystemsType ? (
                  mainSystemId = ss.id
               ) : null
         )
      })
      // Fetch available system types via API
      // - prepare the API URL 
      let apiUrlRoot = config.resinousGetAllSystemTypesEndpoint
      let category = applicationType
      let iso = "en"
      let apiCompleteUrl = apiUrlRoot+"/"+mainSystemId+"/"+bu+"/"+category+"/"+iso

      axios.get(apiCompleteUrl)
      .then(res=>{ setResinousSystemTypes(res.data) })
      .then(res=>{ setLoading(false) })
      .catch(err => { console.log(err) })


      // If cove selected, get available colors and chips (quartz) for cove
      
        let apiUrlNoVaporBarrierColors = config.resinousMainCalculationEndpoint + "/sqft/" + name.toLowerCase() + '/' + resinousApplication.toLowerCase() + '/no/no/no/no/1/en'

        setAvailableSmallColors([])
        setAvailableLargeColors([])
        setAvailableSmallChipColors([])
        setAvailableLargeChipColors([])

        console.log("test")

      applicationType==="cove" && (
         // Get chip options via API call for sample request for selected product type.
          axios.get(apiUrlNoVaporBarrierColors)
         .then(res => {
            // Sort through response and find which product is for chips, grab the chip options provided.
            res.data.map(r => {
               return (     
                   r.colors && (
                       // If it's chip or quartz
                       r.theseAreChipColors == "true" || r.theseAreQuartzColors == "true" ? (
                           r.unitSize.toLowerCase() == "small units" ? (
                               setAvailableSmallChipColors(JSON.parse(r.colors))
                           ) : setAvailableLargeChipColors(JSON.parse(r.colors))
                       ) :
                           r.unitSize.toLowerCase() == "small units" ? (
                               setAvailableSmallColors(JSON.parse(r.colors))
                           ) : setAvailableLargeColors(JSON.parse(r.colors))
                   )
               )
            })
         }) 
      )
   }

   return (    
      <div className="list-item" key={ id + "-" + name + "-" + shortDescription }>
         <div className="row p-1">
            <div className="col-xs-12 col-sm-3 hidden-xs">
               <figure className="system-image">
                  <img alt="" src={ systemImage || config.missingImageUrl } className="img-responsive" />
               </figure>
            </div>
            <div className="col-xs-12 col-sm-9">
               <div className="row p-1">
                  <div className="col-xs-12 visible-xs">
                     <figure className="system-image">
                        <img alt="" src={ systemImage || config.missingImageUrl } className="img-responsive" />
                     </figure>
                  </div>
                  <div className="col-xs-12 col-sm-8 col-lg-9">
                  <h4>{ name } { shortDescription && <small>{ shortDescription }</small> }</h4>
                  </div>
                  <div className="col-xs-12 col-sm-4 col-lg-3 hidden-xs">
                     <button className="btn btn-primary btn-block" onClick={() => handleResinousSystemSelected()}>SELECT</button>
                  </div>
               </div>
               <div className="row p-1">
                  <div className="col-xs-12">
                     <p>{ cleanStringOfChar(description, '&nbsp;', ' ') }</p>
                     {
                        // Only show "Learn More" link if a systemUrl is available.
                               systemUrl && <a href={prepareProductUrl(systemUrl) } rel="noopener noreferrer" target="_blank">Learn More { iconAngleRight }</a>
                     }
                     <button className="btn btn-primary btn-block visible-xs" onClick={() => handleResinousSystemSelected()}>SELECT</button>
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}


// WEBPACK FOOTER //
// ./src/components/productTypes/resinous/ResinousSystem.js